import { MasterAwardRequest } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateMasterAward: (
  fetchContext: FetchContext,
  masterAwardId: number,
  masterAward: MasterAwardRequest,
  accessToken?: string,
) => Promise<void> = async (fetchContext, masterAwardId, masterAward, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/admin/master-awards/${masterAwardId}`,
  {
    method: 'PUT',
    body: JSON.stringify(masterAward),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update master award'));
